import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getCookie } from "../getcookie";
import { apiCallAdmin } from "../service/api-service";
import crmLogo from "../../assets/svg/crm_logo.svg";
import Loader from "./Loader.jsx";
import "./pre-landing.css";

const PreLanding = () => {
  const navigate = useNavigate();
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;

  useEffect(() => {
    const checkAuthAndFetchPermissions = async () => {
      try {
       /*  // Check if user is authenticated
        const token = getCookie("mawalog");

        if (!token) {
          // No token, redirect to login
          // window.location.href = `${accountsUrl}/login`;
          return;
        } */

        // Verify token is still valid
        const validateResponse = await apiCallAdmin("GET", "validatetoken");

        if (validateResponse.status !== 200) {
          // Invalid token, redirect to login
          document.cookie =
            "mawalog=; path=/; domain=.mawalog.com; expires=Thu, 01 Jan 1970 00:00:00 GMT";
          // window.location.href = `${accountsUrl}/login`;
          return;
        }

        // Token is valid, fetch permissions and redirect to dashboard
        const permissionResponse = await apiCallAdmin(
          "GET",
          "get_role_permission/24",
        );

        if (permissionResponse.status === 200) {
          // Store permissions in global context/localStorage
          if (permissionResponse.data.role_permission) {
            localStorage.setItem(
              "rolePermissionList",
              JSON.stringify(permissionResponse.data.role_permission)
            );
          }
          if (permissionResponse.data.user_type) {
            localStorage.setItem("userType", permissionResponse.data.user_type);
          }

          // Navigate to dashboard
          navigate("/dashboard");
          return;
        }

        // If we get here, something went wrong
        console.error("Failed to fetch permissions:", permissionResponse);
        // window.location.href = `${accountsUrl}/login`;
      } catch (error) {
        console.error("Error during auth check:", error);

        // Clear invalid token
        document.cookie =
          "mawalog=; path=/; domain=.mawalog.com; expires=Thu, 01 Jan 1970 00:00:00 GMT";

        // Redirect to login
        // window.location.href = `${accountsUrl}/login`;
      }
    };

    checkAuthAndFetchPermissions();
  }, [navigate, accountsUrl]);

  return (
    <div
      className="pre-landing-container"
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #ffffff 0%, #f8f9fb 100%)",
        padding: "0",
        margin: "0",
        overflow: "hidden",
        position: "fixed",
        top: "0",
        left: "0",
        zIndex: "9999",
      }}
    >
      <div className="pre-landing-content">
        {/* <img
          src={crmLogo}
          alt="CRM Logo"
          className="pre-landing-logo"
          width="200px"
        /> */}
        <Loader height="120px" />
       {/*  <p className="pre-landing-text">Loading CRM...</p> */}
      </div>
    </div>
  );
};

export default PreLanding;
